export const CLASS_NAMES = {
  row: 'flex flex-row items-center justify-between',
  alert: 'mt-4',
};
